import Home from './components/Home.vue';

const About = resolve => {
    require.ensure(['./components/About.vue'], () => {
        resolve(require('./components/About.vue'));
    });
};

const Results = resolve => {
    require.ensure(['./components/results/Results.vue'], () => {
        resolve(require('./components/results/Results.vue'));
    });
};

const WorldRecords = resolve => {
    require.ensure(['./components/world-records/WorldRecords.vue'], () => {
        resolve(require('./components/world-records/WorldRecords.vue'));
    });
};

const Contact = resolve => {
    require.ensure(['./components/Contact.vue'], () => {
        resolve(require('./components/Contact.vue'));
    });
};

const siteTitle = "Jon Scannell";

const routes = [
    { path: '/', component: Home, meta: { title: siteTitle } },
    { path: '/about', component: About, meta: { title: "About | " + siteTitle } },
    { path: '/results', component: Results, meta: { title: "Results | " + siteTitle } },
    { path: '/world-records', component: WorldRecords, meta: { title: "World Records | " + siteTitle } },
    { path: '/contact', component: Contact, meta: { title: "Contact | " + siteTitle } }
]

export default routes;
